import * as React from 'react'

import { type Colors, Icon, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

interface Props {
  information: string | React.ReactNode
  icon?: React.ComponentProps<typeof Icon.Small>['icon']
  color?: Colors
}

// TODO: Move this to a molecule?
const InformationTooltip = ({ information, color = 'grey800', icon = 'info' }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Alt attachment="bottom center" open={open} toggle={toggle} label={information}>
      <Icon.Small icon={icon} encircled={color} />
    </Tooltip.Alt>
  )
}

export default InformationTooltip
